function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import FlipToggle from './FlipToggle';

var Flip =
/*#__PURE__*/
function () {
  function Flip(node) {
    _classCallCheck(this, Flip);

    this.node = node;
    this.toggleAgents = this.buildToggleAgents();
  }

  _createClass(Flip, [{
    key: "buildToggleAgents",
    value: function buildToggleAgents() {
      var _this = this;

      var toggleNodes = Array.from(this.node.querySelectorAll('.flip__toggle'));
      var subFlipNodes = Array.from(this.node.querySelectorAll('.flip__target'));
      var subToggleNodes = subFlipNodes.map(function (node) {
        return node.querySelectorAll('.flip__toggle');
      }).reduce(function (a, nodes) {
        return [].concat(_toConsumableArray(a), _toConsumableArray(nodes));
      }, []);
      var thisToggles = toggleNodes.filter(function (x) {
        return subToggleNodes.indexOf(x) === -1;
      });
      if (!thisToggles.length) return [];
      return thisToggles.map(function (node) {
        return new FlipToggle(node, _this);
      });
    }
  }, {
    key: "closeFlipOpenedToggles",
    value: function closeFlipOpenedToggles() {
      this.toggleAgents.forEach(function (toggleAgent) {
        return toggleAgent.closeOpenedToggle();
      });
    }
  }, {
    key: "makeActive",
    value: function makeActive() {
      this.node.classList.add('flip_active');
    }
  }, {
    key: "makeInactive",
    value: function makeInactive() {
      this.node.classList.remove('flip_active');
      this.toggleAgents.forEach(function (toggleAgent) {
        return toggleAgent.makeInactive();
      });
    }
  }]);

  return Flip;
}();

export { Flip as default };